// you can import modules from the theme lib or even from
// NPM packages if they support it…

// you can also require modules if they support it…
import GLightbox from 'glightbox';
import {gsap} from "gsap";

import Swiper, {Navigation, Pagination, Controller} from 'swiper';

Swiper.use([Navigation, Pagination]);



import Waypoint from "./components/jquery.waypoints.min";


var Odometer = require('odometer');

// Initialise our components on jQuery.ready…
jQuery(function ($) {

    if ($('#home-slider').length > 0) {

        var $slides = $(".slide");   // Slides
        var $dots = $("#dots li");   // Dots
        var currentSlide = 0;        // Current slide index
        var slideTime = 3;         // Fade in / fade out time

        // Hide all slides except the first one
        gsap.set($slides.filter(":gt(0)"), { autoAlpha: 0 });

        // Set initial active dot
        $dots.css({ opacity: 0.5 });
        $dots.eq(currentSlide).css({ opacity: 1 });

        function goToSlide(index) {
            if (index === currentSlide) return;

            gsap.to($slides.eq(currentSlide), slideTime, { autoAlpha: 0 });

            currentSlide = index;

            gsap.to($slides.eq(currentSlide), slideTime, { autoAlpha: 1 });

            updateDots();
        }

        function nextSlide() {
            var nextIndex = (currentSlide + 1) % $slides.length;
            goToSlide(nextIndex);
        }

        function prevSlide() {
            var prevIndex = (currentSlide - 1 + $slides.length) % $slides.length;
            goToSlide(prevIndex);
        }

        function updateDots() {
            $dots.css({ opacity: 0.5 });
            $dots.eq(currentSlide).css({ opacity: 1 });
        }

        // Click event for dots
        $dots.on("click", function () {
            var index = $(this).index();
            goToSlide(index);
        });

        $('#home-slider-next').on('click', function (e) {
            e.preventDefault();
            nextSlide();
        });

        $('#home-slider-prev').on('click', function (e) {
            e.preventDefault();
            prevSlide();
        });

        // Auto-slide every 3 seconds
        setInterval(function () {
            nextSlide();
        }, 3000);
    }


    if ($('#newhome-slider').length > 0) {

        let $slides = $(".slide");			//slides
        let currentSlide = 0;				//keep track on the current slide
        let slideTime = 1.3;				//fade in / fade out time
        let lastTime = 0;

        gsap.set($slides.filter(":gt(0)"), {autoAlpha: 0});	//we hide all images after the first one


        const video = document.getElementById("banner-video");

        const triggers = [
            {time: 4, action: () => videoNextSlide("4 seconds reached!"), triggered: false},
            {time: 8, action: () => videoNextSlide("8 seconds reached!"), triggered: false},
            {time: 18, action: () => videoNextSlide("18 seconds reached!"), triggered: false},
            {time: 21, action: () => videoNextSlide("21 seconds reached!"), triggered: false}
        ];

        video.addEventListener("timeupdate", () => {
            const currentTime = Math.floor(video.currentTime);

            // Detect when the video has restarted (looped back to the beginning)
            if (currentTime < lastTime) {
                console.log("Video looped or restarted");
                triggers.forEach(trigger => {
                    trigger.triggered = false;
                });
            }

            triggers.forEach(trigger => {
                if (currentTime === trigger.time && !trigger.triggered) {
                    trigger.action();
                    trigger.triggered = true;
                }
            });

            lastTime = currentTime;
        });

        function videoNextSlide(time) {

            console.log(time);

            // Instant
            $slides.eq(currentSlide).css({opacity: 0, visibility: "hidden"});
            currentSlide = ++currentSlide % $slides.length;
            $slides.eq(currentSlide).css({opacity: 1, visibility: "visible"});

            /*
            // Fade
            gsap.to($slides.eq(currentSlide), slideTime, {autoAlpha: 0});		//fade out the old slide
            currentSlide = ++currentSlide % $slides.length;						//find out which is the next slide
            gsap.to($slides.eq(currentSlide), slideTime, {autoAlpha: 1});		//fade in the next slide
             */
        }

    }


    $('#filter').submit(function () {
        var filter = $('#filter');
        $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
            beforeSend: function (xhr) {
                filter.find('button').text('Processing...'); // changing the button label
            },
            success: function (data) {
                filter.find('button').text('Apply filter'); // changing the button label back
                $('#response').html(data); // insert data
            }
        });
        return false;
    });


    $('#menu-toggle').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        $('html').toggleClass('menu-active');
    });


    document.addEventListener('wpcf7mailsent', function (event) {
        var inputs = event.detail.inputs;

        console.log('ppc fired');
        if ($('#seo-title').length > 0) {
            var label = $('#seo-title').data('ppc');
            console.log('ppc ' + label);
            gtag('event', 'Download', {
                'event_category': 'Download',
                'event_label': label,
                'event_action': 'Brochure',
            });
        }

        if ($('#seo-title-alt').length > 0) {
            var label = $('#seo-title-alt').data('ppc');
            console.log('ppc ' + label);
            gtag('event', 'Form', {
                'event_category': 'Form',
                'event_label': label,
                'event_action': 'Contact',
            });
        }

        if ($('#seo-title-landing').length > 0) {
            var label = $('#seo-title-landing').data('ppc');
            console.log('ppc ' + label);
            gtag('event', 'Form', {
                'event_category': 'Form',
                'event_label': label,
                'event_action': 'Register',
            });
        }

    }, false);

    var odGroups = [];
    var odValues = [];

    $('.stat-figure').each(function () {
        var o = new Odometer({
            el: this,
            value: '00'
        });
        odGroups.push(o);
        odValues.push($(this).data('stat'))
    });

    var wayStats = $('.stats').waypoint({
        handler: function (direction) {
            if (direction === 'down') {
                for (var i in odGroups) {
                    odGroups[i].update(odValues[i]);
                }
            }
        },
        offset: '80%'
    });


    if ($('#sticky-footer').length > 0) {
        $(document).scroll(function () {
            if ($(window).scrollTop() + $(window).height() == $(document).height()) {
                $('#sticky-footer').removeClass('show-footer');
            } else {
                $('#sticky-footer').toggleClass('show-footer', $(document).scrollTop() >= 50);
            }
        });
    }

    function videoTrigger() {
        var heroVid = document.getElementById("banner-video");

        if (typeof (heroVid) != 'undefined' && heroVid != null) {
            heroVid.muted = true;
            heroVid.play();
            heroVid.addEventListener('oncanplay', function () {
                heroVid.play();
            }, false);
            heroVid.addEventListener('canplaythrough', function () {
                heroVid.play();
            }, false);
            $('#toggle-sound').on('click', function (e) {
                e.preventDefault();
                var that = $(this),
                    icon = that.find('.fas'),
                    text = that.find('.text');

                if (heroVid.muted == true) {
                    heroVid.muted = false;
                    icon.removeClass('fa-volume-off');
                    icon.addClass('fa-volume');
                    text.html('Mute')
                } else {
                    heroVid.muted = true;
                    icon.removeClass('fa-volume');
                    icon.addClass('fa-volume-off');
                    text.html('Unmute')
                }
            });
        }
    }

    videoTrigger();


    var url = window.location.search;

    document.querySelectorAll('a').forEach(function (item) {
        item.href += url;
    });

    const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
    });


    new Swiper('.swiper', {
        loop: true,
        slidesPerView: 1,
        speed: 1000,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            }
        }
    });

});